import { getEmployees } from "./employees";
import { generateReport, getCategories, getReports } from "./report";
import { getTags } from "./tags";

const executeService = {
  getCategories,
  getReports,
  getTags,
  getEmployees,
  generateReport,
};

export { executeService };
